const MEDS_WEB_URL =
  process.env.REACT_APP_MEDS_WEB_URL || "https://meds-web-stage.curebay.in";
const API_BASE = process.env.REACT_APP_NEW_DOCTOR_URL || "";

export async function callMedsVerifyPasswordApi() {
  const clinicId = localStorage.getItem("clinicId");
  if (!clinicId) throw new Error("Clinic ID not found.");

  const res = await fetch(`${API_BASE}/api/v1/retailers/${clinicId}`);
  const data = await res.json();

  if (!res.ok) throw new Error(data?.message || "Failed to load retailer.");

  const { token, refreshToken } = data;
  if (!token || !refreshToken) throw new Error("Missing token from retailer API.");

  localStorage.setItem("meds_jwt_token", token);
  localStorage.setItem("meds_refresh_token", refreshToken);

  const loginUrl = `${MEDS_WEB_URL}/auth-login#accessToken=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}`;
  window.open(loginUrl, "_blank");

  return { loginUrl };
}
